"use client";

import Image from "next/image";
import { agentPlatformLinks, socialLinks } from "@/components/prv/data";

const paymentMethods = [
  { label: "PayPal", logo: "/images/footer/payment-paypal.svg", tone: "paypal" },
  { label: "Visa", logo: "/images/footer/payment-visa.svg", tone: "visa" },
  { label: "Mastercard", logo: "/images/footer/payment-mastercard.svg", tone: "mastercard" },
  { label: "American Express", logo: "/images/footer/payment-amex.svg", tone: "amex" },
  { label: "Discover", logo: "/images/footer/payment-discover.svg", tone: "discover" },
  { label: "Apple Pay", logo: "/images/footer/payment-apple-pay.svg", tone: "applepay" },
  { label: "Google Pay", logo: "/images/footer/payment-google-pay.svg", tone: "googlepay" },
];

export function SiteFooter() {
  return (
    <footer className="footer-section" id="support">
      <div className="footer-top">
        <div className="footer-brand">
          <span className="footer-logo-frame" aria-hidden="true">
            <Image
              src="/images/prvbuy-logo-p-flat.png"
              alt=""
              width={96}
              height={96}
              className="footer-logo-img"
            />
          </span>
          <div>
            <span>PRVBUY.COM</span>
            <p>Your private buying agent in China.</p>
          </div>
        </div>
      </div>

      <div className="footer-grid">
        <div>
          <h3>Help & Policies</h3>
          <a href="/help-center">Help Center</a>
          <a href="/shipping-policy">Shipping Policy</a>
          <a href="/returns-and-refunds">Returns & Refunds</a>
          <a href="/prohibited-items">Prohibited Items Policy</a>
          <a href="/anti-counterfeiting-policy">Anti-Counterfeiting Policy</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
        </div>
        <div>
          <h3>Company</h3>
          <a href="/about">About PRVBUY</a>
          <a href="/contact">Contact Us</a>
        </div>
        <div>
          <h3>Programs</h3>
          <a href="/affiliate-program">Affiliate Program</a>
          <a href="/promotions">Promotions</a>
        </div>
        <div>
          <h3>Resources</h3>
          <a href="/shipping-estimate">Shipping Estimate</a>
          <a href="/diy-order">DIY Order</a>
        </div>
      </div>

      <div className="footer-card-row">
        <div className="footer-card-group">
          <h3>Agent Platforms</h3>
          <div className="platform-card-grid" aria-label="Agent platform cards">
            {agentPlatformLinks.map((platform) => (
              <a
                className={`platformCard ${platform.tone}`}
                href={platform.href}
                key={platform.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={platform.logo}
                  alt={platform.label}
                  width={240}
                  height={96}
                  className="footer-logo-asset"
                  loading="eager"
                  unoptimized
                />
              </a>
            ))}
          </div>
        </div>
        <div className="footer-card-group">
          <h3>Payment Methods</h3>
          <div className="payment-grid" aria-label="Payment methods">
            {paymentMethods.map((method) => (
              <span className={`paymentCard ${method.tone}`} key={method.label}>
                <Image
                  src={method.logo}
                  alt={method.label}
                  width={240}
                  height={96}
                  className="footer-logo-asset"
                  loading="eager"
                  unoptimized
                />
              </span>
            ))}
          </div>
        </div>
        <div className="footer-card-group">
          <h3>Community</h3>
          <div className="social-grid" aria-label="Social and community links">
            {socialLinks.map((community) => (
              <a
                className={`socialIcon ${community.tone}`}
                href={community.href ?? "#"}
                key={community.label}
                aria-label={community.href ? community.label : `${community.label} coming soon`}
                aria-disabled={community.href ? undefined : true}
                title={community.href ? community.label : `${community.label} coming soon`}
                target={community.href ? "_blank" : undefined}
                rel={community.href ? "noopener noreferrer" : undefined}
                onClick={community.href ? undefined : (event) => event.preventDefault()}
              >
                <Image
                  src={community.logo}
                  alt=""
                  width={96}
                  height={96}
                  aria-hidden="true"
                  loading="eager"
                  unoptimized
                />
                <span>{community.label}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      <p className="legal">
        PRVBUY.COM
        <br />
        Your private buying agent in China.
        <br />
        Purchase, inspect, store and ship — all managed for you.
      </p>
    </footer>
  );
}
